import { Component, OnInit } from '@angular/core';
import { ApiIntegration } from '../../_services/api.integration';
import { Globals } from '../../_models/globals';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { User } from '../../_models/user';

@Component({
  selector: 'app-warehouse-view',
  templateUrl: './warehouse-view.component.html',
  styleUrls: ['./warehouse-view.component.css']
})
export class WarehouseViewComponent implements OnInit {
  warehouseTypesList: any;
  wareHouseView: any = {};
  wareHouseListView: any;
  accountOwnerData: any;

  constructor(private http: HttpClient, private router: Router, private route: ActivatedRoute, private api: ApiIntegration, private g: Globals, public user: User) {
    this.g.page = "Warehouse View";
    this.g.loaderDisplay = "display";
    this.api.getAccOwnersByWarehouseId(this.route.snapshot.params['id'], this.user.organizationId).subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.wareHouseView = data; this.wareHouseListView = data.accountOwnerData;
    }, err => {
      console.log(err);
      this.g.loaderDisplay = "";
    });
  }

  ngOnInit() {
  }

}
